import { render, staticRenderFns } from "./EditContactPerson.vue?vue&type=template&id=30e58071&"
import script from "./EditContactPerson.vue?vue&type=script&lang=js&"
export * from "./EditContactPerson.vue?vue&type=script&lang=js&"
import style0 from "./EditContactPerson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports